export default __webpack_public_path__ + "0a4a710c1b71e199a7cc22baa1a58ab5.svg";